import React, { useState, useEffect } from "react";
import { Dialog, Button, Box } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const PdfViewer = ({
  open,
  onClose,
  previewImage,
  useDialog,
  isPdf,
  setPageNumber,
  pageNumber,
  isVideo,
  file
}) => {
  const [fileType, setFileType] = useState("");

  const [numPages, setNumPages] = useState(null);

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const getFileType = (url) => {
    if (url?.endsWith(".pdf") || url?.endsWith(".PDF") ) {
      return "pdf";
    } else if (
      url?.endsWith(".jpg") ||
      url?.endsWith(".jpeg") ||
      url?.endsWith(".png")
    ) {
      return "image";
    } else if (url?.endsWith(".video") ) {
      return "video"
    } else {
      return "";
    }
  };

  // Set the file type when the component mounts
  useEffect(() => {
    setFileType(getFileType(previewImage));
  }, [previewImage]);

  const renderFilePreview = () => {
    if (fileType === "pdf") {
      return (
        <embed
          src={previewImage}
          type="application/pdf"
          width="100%"
          height="500px"
        />
      );
    } else if (fileType === "image") {
      return (
        <img
          src={previewImage}
          alt="File preview"
          style={{ maxWidth: "100%", maxHeight: "600px" }}
        />
      );
    } else if (fileType === "video") {
      return (
        <video 
        controls 
        style={{ 
          maxWidth: '100%', 
          maxHeight: '80vh',
          width: '100%',
          height: 'auto'
        }}
      >
        <source src={previewImage} type={file?.type} />
        Your browser does not support the video tag.
      </video>
      )
    }
  };

  if (useDialog) {
    return (
      <Dialog open={open} onClose={onClose}         
      maxWidth="md" 
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '90vh',
          maxWidth: '600px'
        },
      }}
      >
        {isPdf ? (
          <div>
            <div style={{ height: "500px", width: "700px", overflow: "auto" }}>
              <Document
                file={previewImage}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                <Page pageNumber={pageNumber} />
              </Document>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "5px 0px 5px 0px",
                gap: "5px",
              }}
            >
              <Button
                onClick={previousPage}
                disabled={pageNumber <= 1}
                variant="contained"
                color="primary"
              >
                Previous
              </Button>
              <Button
                onClick={nextPage}
                disabled={pageNumber >= numPages}
                variant="contained"
                color="primary"
              >
                Next
              </Button>
            </div>
          </div>
        ) : isVideo ? (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            height: '100%',
            width: '100%'
          }}>
            <video 
                controls 
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '80vh',
                  width: '100%',
                  height: 'auto'
                }}
            >
                <source src={previewImage} type={file?.type} />
                Your browser does not support the video tag.
            </video>
       </Box>
        ) : (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            height: '100%',
            width: '100%'
          }}>
             <img 
                src={previewImage} 
                alt="Preview" 
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '80vh', 
                  objectFit: 'contain' 
                }} 
              />
          </Box>
        )}
      </Dialog>
    );
  } else {
    return <div>{renderFilePreview()}</div>;
  }
};

export default PdfViewer;
